var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"sust-tooltip",rawName:"v-sust-tooltip",value:({
    text: _vm.$t(`approval.options.${_vm.approval_option.key}`),
    fontSize: '.8em'
  }),expression:"{\n    text: $t(`approval.options.${approval_option.key}`),\n    fontSize: '.8em'\n  }"}],class:_vm.approval_option.icon,style:({ 'color': _vm.approval_option.bgColor })})
}
var staticRenderFns = []

export { render, staticRenderFns }